import getTranslations from "../../../i18n";
import { hydrate } from "react-dom";
import App from "../../containers/App";
import { getLocale } from "../../state/modules/config/selectors";
import { loadableReady } from "@loadable/component";
import getSavedItemsSummary from "../saveForLater/getSavedItemsSummary";
import loadPolyfills from "./loadPolyfills";
import removeScrollToQuery from "../../helpers/removeScrollToQuery";
import { history } from "../history";
import ClientRouter from "../../containers/ClientRouter";
import initialiseAdvertsSdk from "../adverts/initialiseAdvertsSdk";
import {
  loadLoyaltyCustomerTierId,
  loadLoyaltyIsEnabled,
  loadLoyaltyIsEarlyAccessSaleAvailableForTier,
  loadLoyaltyIsEarlyAccessSaleEventActive,
  loadLoyaltyIsMembersOnlySaleAvailableForTier,
  loadLoyaltyGetActiveMembersDaySaleEvent,
  loadEnableComplianceVariant,
} from "../../state/modules/config/actions";
import newInRedirect from "../clientSideRedirect/newInRedirect";

const bootstrapReact = async (store) => {
  newInRedirect({ state: store.getState() });
  await loadPolyfills();

  initialiseAdvertsSdk(store);

  store.dispatch(getSavedItemsSummary());
  store.dispatch(loadLoyaltyIsEnabled());
  store.dispatch(loadLoyaltyCustomerTierId());
  store.dispatch(loadLoyaltyIsEarlyAccessSaleAvailableForTier());
  store.dispatch(loadLoyaltyIsEarlyAccessSaleEventActive());
  store.dispatch(loadLoyaltyIsMembersOnlySaleAvailableForTier());
  store.dispatch(loadLoyaltyGetActiveMembersDaySaleEvent());
  store.dispatch(loadEnableComplianceVariant());

  removeScrollToQuery(history);

  const [translations] = await Promise.all([
    getTranslations(getLocale(store.getState())),
  ]);

  loadableReady(() => {
    hydrate(
      <App
        store={store}
        translations={translations}
        RouterComponent={ClientRouter}
      />,
      document.getElementById("plp"),
    );
  });
};

export default bootstrapReact;
